import apiClient from "../../../api-client";
import getWrappedUseQuery from "../../helpers/getWrappedUseQuery";
import KEYS from "../keys";

export const useForumVisualSpeakerDocumentsQuery = getWrappedUseQuery(
  KEYS.GET_FORUM_VISUAL_SPEAKER_DOCUMENTS,
  apiClient.ForumVisualSpeakerDocument.get,
);
